// src/common/wrappers/i18n.js

'use strict';

const getNestedProperty = require('./nested-property');

let currentLang;
let i18nHash = {};

const i18n = (path, keys) => {
  const hash = typeof WEBPACK_I18N !== 'undefined' ? WEBPACK_I18N : i18nHash;
  const src = hash[currentLang];
  const result = getNestedProperty(src, path) || {};

  if (Array.isArray(keys)) {
    keys.forEach(function (key) {
      result[key] = result[key] || '';
    });
  }

  return result;
};

i18n.setI18nSource = (lang, src) => {
  i18nHash[lang] = src;
};


/**
 * Сохранить локаль для всего приложения в моделе-синглтоне
 * При дальнейшем вызове i18n во всем приложении будет использован заданная локаль
 *
 * @param {string} lang
 *
 * @example
 * setLang('en')
 */
i18n.setLang = (lang = 'ru') => {
  currentLang = lang;
};

module.exports = i18n;
